/**
 * MCP tools exposed by @sica/mcp.
 *
 * Mirrors the announced catalogue in packages/mcp/src/tools/registry.ts. A tool
 * published here that the server does not implement is the same defect as one
 * announced by the server itself — the reader cannot tell it is not real.
 *
 * Decision 12.7 (ADR-005 §7): MCP docs are real at launch — these reflect actual code.
 */

export type McpToolParam = {
  name: string;
  type: string;
  required: boolean;
  description: string;
};

export type McpTool = {
  name: string;
  description: string;
  params: ReadonlyArray<McpToolParam>;
  example: string;
};

export const MCP_TOOLS: readonly McpTool[] = [
  {
    name: 'search_standards',
    description:
      'Buscá fragmentos curriculares específicos y estándares en la normativa educativa argentina. Devuelve coincidencias con metadata (jurisdicción, página, fragmento).',
    params: [
      {
        name: 'query',
        type: 'string',
        required: true,
        description: 'La consulta de búsqueda (ej.: "numeración hasta el 100").',
      },
      {
        name: 'jurisdiction',
        type: 'string',
        required: false,
        description: 'Filtrar por jurisdicción (ej.: "CABA", "Nacional").',
      },
    ],
    example: `{
  "name": "search_standards",
  "arguments": {
    "query": "numeración hasta el 100",
    "jurisdiction": "Nacional"
  }
}`,
  },
  {
    name: 'get_design_context',
    description:
      'Cargá el contexto completo de un diseño curricular para una jurisdicción y un nivel específicos. Devuelve los fragmentos del documento referenciado.',
    params: [
      {
        name: 'assetId',
        type: 'string',
        required: true,
        description: 'ID único del activo curricular en el IAC.',
      },
    ],
    example: `{
  "name": "get_design_context",
  "arguments": {
    "assetId": "iac-caba-primaria-2024"
  }
}`,
  },
];

export const MCP_SERVER_INFO = {
  name: 'sica-mcp-server',
  version: '1.0.0',
  protocolVersion: '2024-11-05',
  defaultPort: 9012,
  transports: ['stdio', 'http', 'sse'] as const,
};
